module.exports = __webpack_public_path__ + "static/media/refil-fr600.975636bd.webp";